import I18n from 'I18n';
export const formatNumbersInString = text => text.replace(/\b\d+\b/g, match => I18n.formatNumber(I18n.parseNumber(match)));